import { Component, OnInit } from '@angular/core';
import { NewFilters } from '@/common/new-filters';
import { TasksService } from '../../tasks.service';
import { Kind, Status, User } from '../../task.model';
import { concat, debounceTime, distinctUntilChanged, filter, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { DateAdapter } from '@angular/material/core';

@Component({
	selector: 'app-general-tasks-filter',
	templateUrl: './general-tasks-filter.component.html',
	styleUrls: ['./general-tasks-filter.component.scss'],
	providers: [NewFilters],
})
export class GeneralTasksFilterComponent implements OnInit {
	constructor(
		protected filters: NewFilters,
		protected service: TasksService,
		private readonly dateAdapter: DateAdapter<Date>,
	) {
		this.filters.url = '/task_note/task/';
		this.dateAdapter.setLocale('pl-PL');
	}

	protected statuses: Status[];
	protected kinds: Kind[];
	protected users$: Observable<User[]>;
	protected usersLoading = false;
	protected usersInput$ = new Subject<string>();
	protected minLengthFullName = 3;
	private loggedUser: User;
	protected filtersLoading = false;
	protected buttonLoading = false;

	async ngOnInit(): Promise<void> {
		this.filtersLoading = true;
		this.loggedUser = await this.service.loadProfile();
		this.loadUsers();
		const [taskStatuses, taskKinds] = await Promise.all([
			this.service.loadTasksStatus(),
			this.service.loadTaskKinds(),
		]);
		this.statuses = taskStatuses;
		this.kinds = taskKinds;
		this.filters.controls = [
			{
				name: 'status',
				initialValue: this.statuses.find((v) => v.name === 'W trakcie').id,
			},
			{
				name: 'kinds',
				separator: '&kinds=',
				multiple: true,
			},
			{
				name: 'users__id__in',
				multiple: true,
				initialValue: this.loggedUser.id,
			},
			{
				name: 'deadline__gte',
			},
			{
				name: 'deadline__lte',
			},
		];
		this.filters.parameters = {
			limit: '999',
		};
		this.filters.createFormGroup();
		this.setFilters();
		this.filtersLoading = false;
	}

	setFilters() {
		this.buttonLoading = true;
		this.filters.submit().then((result) => {
			this.service.dataSource.data = result.results;
			this.service.parameters.next(result.results);
			this.buttonLoading = false;
		});
	}

	private loadUsers() {
		this.users$ = concat(
			of([this.loggedUser]),
			this.usersInput$.pipe(
				filter((res) => {
					return res !== null && res.length >= this.minLengthFullName;
				}),
				distinctUntilChanged(),
				debounceTime(800),
				tap(() => (this.usersLoading = true)),
				switchMap((fullName) => {
					return this.service.loadUsers(fullName).pipe(tap(() => (this.usersLoading = false)));
				}),
			),
		);
	}

	protected clearDateRange() {
		this.filters.filtersFormGroup.get('deadline__gte').reset();
		this.filters.filtersFormGroup.get('deadline__lte').reset();
	}
}
